<template>
    <div class="canvas">
        <div class="text-right" >
            <span @click="goHome" style="cursor:pointer; margin-right: 25px;">返回首页</span>
            <span @click="goBackList" style="cursor:pointer">返回{{ positionName }}</span>
            <!-- <img src="../../assets/images/fanhui.svg" alt="" /> -->
        </div>
        <el-divider></el-divider>
        <div class="line"></div>
        <div class="canvas-title">{{docInfo.doc_name}}</div>
        <el-row class="canvas-title-details">
            <el-col cols="12" class="details-ci">
                <img src="../../assets/images/eye.png" alt="">
                <span class="num-ci">浏览：{{docInfo.access_count?docInfo.access_count:0}}次</span>
                <img src="../../assets/images/shizhong.svg" alt="">
                <span class="date">发布时间：{{docInfo.create_date}}</span>
            </el-col>
        </el-row>
        <div id="content" class="content ql-editor"></div>
        <el-divider></el-divider>
        <div class="layout-title" v-if="files.length">
            <p>附件信息</p>
            <ul>
                <li v-for="item in files" :key="item.attach_id" class="layout-file__item f-active">
                    <div @click="download(item)" style="cursor:pointer">
                    <span href="javascript:">{{item.attach_name}}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="mt-20"></div>    
    </div>
</template>
<script>
import {
    getDocBaseInfoByIdApi,
    updateDocBaseInfoCntApi
} from "@/api"
import { download } from "@/request/utils";
export default {
    name: 'doc-info-wrapper',
    data () {
        return {
            list: [],
            docId:'',
            docInfo: {},
            files:[],
            position:'',
            positionName:''
        }
    },
    created(){
        this.docId = this.$route.query.docId
        this.position = this.$route.query.position
        this.positionName = this.$route.query.positionName
        this.getDocInfo({ doc_id: this.docId })
        this.updatCnt({ doc_id: this.docId })
    },
    methods: {
        async getDocInfo(param){
            const { data } = await getDocBaseInfoByIdApi(param)
            console.log(data,'link')
            console.log(data.docBase,'docBase')
            this.docInfo = data.docBase
            this.files = data.docAttachList
            document.getElementById('content').innerHTML = data.docBase.doc_content
        },
        updatCnt(param){
            updateDocBaseInfoCntApi(param)
        },
        download(item){ //下载文件
            const path = `${CONFIG.UPLOAD_CONFIG.URL}/file/DownloadFile/${item.attach_id}`;
            download(path, item.attach_name, item.attach_type);
        },
        goHome(){
            this.$router.push({
                path: '/home'
            }, () => {})
        },
        goBackList(){
            this.$router.push({
                path: this.position
            }, () => {})
        }
    }
}
</script>
  <style lang="scss" scoped>
  @import './DocInfo.scss';
  @import './editor.css';
  </style>
